import { render, staticRenderFns } from "./SpinnerSheet.vue?vue&type=template&id=740b5240&scoped=true"
import script from "./SpinnerSheet.vue?vue&type=script&lang=js"
export * from "./SpinnerSheet.vue?vue&type=script&lang=js"
import style0 from "./SpinnerSheet.vue?vue&type=style&index=0&id=740b5240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b5240",
  null
  
)

export default component.exports